export default __webpack_public_path__ + "static/media/pdf-icon-ligh-green.51b51697.svg";